"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SignIn;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _material = require("@mui/material");
var _TabContext = _interopRequireDefault(require("@mui/lab/TabContext"));
var _TabList = _interopRequireDefault(require("@mui/lab/TabList"));
var _TabPanel = _interopRequireDefault(require("@mui/lab/TabPanel"));
var _Tab = _interopRequireDefault(require("@mui/material/Tab"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _EmailPasswordLoginForm = _interopRequireDefault(require("./EmailPasswordLoginForm"));
var _SocialSignInCard = _interopRequireDefault(require("./SocialSignInCard"));
var _CreateAccountForm = _interopRequireDefault(require("./CreateAccountForm"));
var _PasswordForgottenCard = _interopRequireDefault(require("./PasswordForgottenCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function SignIn(props) {
  var _location$state;
  const {
    t,
    globalActions,
    navigate,
    location,
    Link,
    auth,
    authProvider,
    analytics,
    gtcuCookieName,
    ourSignInWithPopup,
    signinCallback,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendEmailVerification,
    logEvent,
    LaboxWSIcon
  } = props;
  const [emailPasswordCardType, setemailPasswordCardType] = (0, _react.useState)('signin');
  const [tab, setTab] = (0, _react.useState)('signin');
  const [afterSignInRedirect] = (0, _react.useState)((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.afterSignInRedirect);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
      mt: 3,
      p: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/_react.default.createElement(LaboxWSIcon, {
    width: "180"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "span",
    variant: "h6"
  }, t('signin.info1'), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "span",
    variant: "h6",
    sx: {
      fontWeight: 'bold',
      color: '#437A89'
    }
  }, t('signin.info2')))), /*#__PURE__*/_react.default.createElement(_SocialSignInCard.default, {
    afterSignInRedirect: afterSignInRedirect,
    t: t,
    analytics: analytics,
    navigate: navigate,
    Link: Link,
    auth: auth,
    authProvider: authProvider,
    gtcuCookieName: gtcuCookieName,
    ourSignInWithPopup: ourSignInWithPopup,
    signinCallback: signinCallback
  }), emailPasswordCardType === 'signin' && /*#__PURE__*/_react.default.createElement(_Card.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      p: 1,
      gap: 1,
      width: {
        xs: '100%',
        sm: '88%'
      },
      maxWidth: 670
    }
  }, /*#__PURE__*/_react.default.createElement(_TabContext.default, {
    value: tab
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, /*#__PURE__*/_react.default.createElement(_TabList.default, {
    onChange: handleTabChange,
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_Tab.default, {
    label: t('signin.login'),
    value: "signin"
  }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
    label: t('signin.register'),
    value: "register"
  }))), /*#__PURE__*/_react.default.createElement(_TabPanel.default, {
    value: "signin"
  }, /*#__PURE__*/_react.default.createElement(_EmailPasswordLoginForm.default, {
    auth: auth,
    afterSignInRedirect: afterSignInRedirect,
    setemailPasswordCardType: setemailPasswordCardType,
    navigate: navigate,
    t: t,
    analytics: analytics,
    Link: Link,
    gtcuCookieName: gtcuCookieName,
    globalActions: globalActions,
    signInWithEmailAndPassword: signInWithEmailAndPassword,
    signinCallback: signinCallback
  })), /*#__PURE__*/_react.default.createElement(_TabPanel.default, {
    value: "register"
  }, /*#__PURE__*/_react.default.createElement(_CreateAccountForm.default, {
    setemailPasswordCardType: setemailPasswordCardType,
    auth: auth,
    navigate: navigate,
    t: t,
    Link: Link,
    analytics: analytics,
    gtcuCookieName: gtcuCookieName,
    createUserWithEmailAndPassword: createUserWithEmailAndPassword,
    sendEmailVerification: sendEmailVerification,
    logEvent: logEvent,
    globalActions: globalActions,
    signinCallback: signinCallback
  })))), emailPasswordCardType === 'passwordForgotten' && /*#__PURE__*/_react.default.createElement(_PasswordForgottenCard.default, {
    setemailPasswordCardType: setemailPasswordCardType,
    t: t,
    auth: auth,
    analytics: analytics,
    Link: Link,
    globalActions: globalActions
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, null, t('welcome.contact_message'), /*#__PURE__*/_react.default.createElement(_material.Link, {
    component: Link,
    to: "/contact",
    color: "primary",
    sx: {
      fontWeight: 'bold'
    }
  }, "contact@labox-apps.com")));
}